<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPageAdPlacement
          :data="adPlacement"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          @submit="fromAdPlacementSubmit"
          @delete-ad-placement="deleteAdPlacement"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmAdPlacementRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormPageAdPlacement from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import createAdPlacement from '@/services/gql/types/AdPlacements/mutations/createAdPlacement.gql'
import deleteAdPlacement from '@/services/gql/types/AdPlacements/mutations/deleteAdPlacement.gql'
import updateAdPlacement from '@/services/gql/types/AdPlacements/mutations/updateAdPlacement.gql'
import adPlacementQuery from '@/services/gql/types/AdPlacements/queries/adPlacement.gql'

export default {
  name: 'PageAdPlacement',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormPageAdPlacement,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать рекламное место' : 'Создать рекламное место'
    }
  },
  data () {
    return {
      adPlacement: {}
    }
  },
  computed: {
    isMutationLoading () {
      return this.$async.createAdPlacement.$pending || this.$async.updateAdPlacement.$pending
    },
    isFormLoading () {
      return (
        this.$apollo.queries.adPlacement.loading
      )
    }
  },
  methods: {
    async fromAdPlacementSubmit (adPlacementPayload) {
      if (!this.id) await this.createAdPlacement(adPlacementPayload)
      else await this.updateAdPlacement(adPlacementPayload)
    },
    async createAdPlacement ({ data }) {
      delete data.translations
      try {
        await this.$async.createAdPlacement.$perform({
          data
        })
        this.$successMsg('Рекламное место создано')
        await this.$router.push({ name: 'page-ad-placements' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании рекламного места')
      }
    },
    async deleteAdPlacement () {
      try {
        await this.$refs.confirmAdPlacementRemoving.open()
        await this.$async.deleteAdPlacement.$perform({ id: Number(this.id) })
        this.$successMsg('Рекламное место удалено')
      } catch (e) {
        this.$handleApiError(
          e,
          `Ошибка при удалении рекламного места с ID ${this.id}`
        )
      } finally {
        await this.$router.push({ name: 'page-ad-placements' })
      }
    },
    async updateAdPlacement ({ data }) {
      try {
        await this.$async.updateAdPlacement.$perform(
          {
            id: Number(this.id),
            data
          }
        )
        this.$successMsg('Рекламного места изменено')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании рекламного места')
      }
    }
  },
  apollo: {
    adPlacement: {
      query: adPlacementQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      context () {
        return {
          headers: {
            'execution-context': 'public'
          }
        }
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-ad-placements' })
        }
      }
    }
  },
  async: {
    createAdPlacement (variables) {
      return this.$apollo.mutate({
        mutation: createAdPlacement,
        variables
      })
    },
    deleteAdPlacement (variables) {
      return this.$apollo.mutate({
        mutation: deleteAdPlacement,
        variables
      })
    },
    updateAdPlacement (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateAdPlacement,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
